import { chatbotConversationAxios } from "../../Utils/Axios";
import { getHttpService } from "../HttpService";
import { CHATBOT_CONVERSATION_ENDPOINTS } from "./Endpoints";

export const BOT_Headers = {
  connection_type: "agent",
};

export class ChatbotConversationService {
  static httpService = getHttpService(chatbotConversationAxios);


  static getHistoryMessages = (queryData = {}, config = {}) => {
    return ChatbotConversationService.httpService.get({
      url: CHATBOT_CONVERSATION_ENDPOINTS.HISTORY,
      params: queryData,
      headers: config,
    });
  };
  
  static getSingleSessionHistoryMessages = (queryData = {}, config = {}) => {
    return ChatbotConversationService.httpService.get({
      url: CHATBOT_CONVERSATION_ENDPOINTS.SINGLE_SESSION_HISTORY,
      params: queryData,
      headers: config,
    });
  };

  static getUserSessionInfo = (queryData = {}, config = {}) => {
    return ChatbotConversationService.httpService.get({
      url: CHATBOT_CONVERSATION_ENDPOINTS.USER_SESSION_INFO,
      params: queryData,
      headers: config,
    });
  };

  static postAgentChat = (queryData = {}, config = {}) => {
    return ChatbotConversationService.httpService.post({
      url: CHATBOT_CONVERSATION_ENDPOINTS.AGENT_CHAT,
      data: queryData,
      headers: config,
    });
  };

  static changeChatStatus = (queryData = {}, config = {}) => {
    return ChatbotConversationService.httpService.post({
      url: CHATBOT_CONVERSATION_ENDPOINTS.CHANGE_STATUS,
      data: queryData,
      headers: config,
    });
  };
  static changeChatStatusBulk = (queryData = {}, config = {}) => {
    return ChatbotConversationService.httpService.post({
      url: CHATBOT_CONVERSATION_ENDPOINTS.BULK_CHANGE_STATUS,
      data: queryData,
      headers: config,
    });
  };

  static joinBotChat = (queryData = {}, config = {}) => {
    return ChatbotConversationService.httpService.post({
      url: CHATBOT_CONVERSATION_ENDPOINTS.JOIN_BOT_CHAT,
      data: queryData,
      headers: config,
    });
  };
}
